export const getLang = (state) => state.lang || { initing: false, lang: 'MM' }
